(function () {
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92
};


function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$var$gameStatus = {
    IDLE: "idle",
    PLAYING: "playing",
    WIN: "win",
    LOSE: "lose"
};
var $3d28d7f1aac198f5$var$defIniState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState || $3d28d7f1aac198f5$var$defIniState;
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.score = 0;
        this.status = $3d28d7f1aac198f5$var$gameStatus.IDLE;
        this.lastMoves = [];
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "selectRandomField",
            value: function selectRandomField() {
                var emptyCells = [];
                for(var x = 0; x < 4; x++){
                    for(var y = 0; y < 4; y++)if (this.state[x][y] === 0) emptyCells.push({
                        x: x,
                        y: y
                    });
                }
                if (emptyCells.length === 0) return null;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                return emptyCells[randomIndex];
            }
        },
        {
            key: "addRandom",
            value: function addRandom() {
                var cell = this.selectRandomField();
                if (cell === null) return;
                var val = Math.random() < 0.1 ? 4 : 2;
                this.state[cell.x][cell.y] = val;
            }
        },
        {
            key: "processLine",
            value: function processLine(array) {
                var filtered = array.map(function(val, idx) {
                    return {
                        val: val,
                        origIdx: idx
                    };
                }).filter(function(el) {
                    return el.val !== 0;
                });
                var res = [];
                var moves = [];
                var i = 0;
                var resultIdx = 0;
                while(i < filtered.length){
                    if (i < filtered.length - 1 && filtered[i].val === filtered[i + 1].val) {
                        res.push(filtered[i].val * 2);
                        this.score += filtered[i].val * 2;
                        moves.push({
                            from: filtered[i].origIdx,
                            to: resultIdx,
                            merged: false
                        });
                        moves.push({
                            from: filtered[i + 1].origIdx,
                            to: resultIdx,
                            merged: true
                        });
                        i += 2;
                    } else {
                        res.push(filtered[i].val);
                        moves.push({
                            from: filtered[i].origIdx,
                            to: resultIdx,
                            merged: false
                        });
                        i += 1;
                    }
                    resultIdx++;
                }
                while(res.length < 4)res.push(0);
                return {
                    result: res,
                    moves: moves
                };
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var _this_processLine = _this.processLine(_this.state[row]), result = _this_processLine.result, moves = _this_processLine.moves;
                    newState.push(result);
                    moves.forEach(function(move) {
                        _this1.lastMoves.push({
                            fromRow: row,
                            fromCol: move.from,
                            toRow: row,
                            toCol: move.to,
                            merged: move.merged
                        });
                    });
                };
                var _this1 = this;
                if (this.status !== $3d28d7f1aac198f5$var$gameStatus.PLAYING) return;
                this.lastMoves = [];
                var newState = [];
                for(var row = 0; row < 4; row++)_loop(row);
                this.state = newState;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.state[row]).reverse();
                    var _this_processLine = _this.processLine(reversed), result = _this_processLine.result, moves = _this_processLine.moves;
                    newState.push(result.reverse());
                    moves.forEach(function(move) {
                        _this1.lastMoves.push({
                            fromRow: row,
                            fromCol: 3 - move.from,
                            toRow: row,
                            toCol: 3 - move.to,
                            merged: move.merged
                        });
                    });
                };
                var _this1 = this;
                if (this.status !== $3d28d7f1aac198f5$var$gameStatus.PLAYING) return;
                this.lastMoves = [];
                var newState = [];
                for(var row = 0; row < 4; row++)_loop(row);
                this.state = newState;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = [
                        _this.state[0][col],
                        _this.state[1][col],
                        _this.state[2][col],
                        _this.state[3][col]
                    ];
                    var _this_processLine = _this.processLine(column), result = _this_processLine.result, moves = _this_processLine.moves;
                    for(var row = 0; row < 4; row++)newState[row][col] = result[row];
                    moves.forEach(function(move) {
                        _this1.lastMoves.push({
                            fromRow: move.from,
                            fromCol: col,
                            toRow: move.to,
                            toCol: col,
                            merged: move.merged
                        });
                    });
                };
                var _this1 = this;
                if (this.status !== $3d28d7f1aac198f5$var$gameStatus.PLAYING) return;
                this.lastMoves = [];
                var newState = [
                    [],
                    [],
                    [],
                    []
                ];
                for(var col = 0; col < 4; col++)_loop(col);
                this.state = newState;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = [
                        _this.state[0][col],
                        _this.state[1][col],
                        _this.state[2][col],
                        _this.state[3][col]
                    ];
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(column).reverse();
                    var _this_processLine = _this.processLine(reversed), result = _this_processLine.result, moves = _this_processLine.moves;
                    var finalResult = result.reverse();
                    for(var row = 0; row < 4; row++)newState[row][col] = finalResult[row];
                    moves.forEach(function(move) {
                        _this1.lastMoves.push({
                            fromRow: 3 - move.from,
                            fromCol: col,
                            toRow: 3 - move.to,
                            toCol: col,
                            merged: move.merged
                        });
                    });
                };
                var _this1 = this;
                if (this.status !== $3d28d7f1aac198f5$var$gameStatus.PLAYING) return;
                this.lastMoves = [];
                var newState = [
                    [],
                    [],
                    [],
                    []
                ];
                for(var col = 0; col < 4; col++)_loop(col);
                this.state = newState;
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                var win = this.state.some(function(el) {
                    return el.some(function(sub) {
                        return sub === 2048;
                    });
                });
                if (win) {
                    this.status = $3d28d7f1aac198f5$var$gameStatus.WIN;
                    return true;
                }
                return false;
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                if (this.state.some(function(el) {
                    return el.some(function(sub) {
                        return sub === 0;
                    });
                })) return false;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var current = this.state[row][col];
                    if (col < 3 && this.state[row][col + 1] === current) return false;
                    if (row < 3 && this.state[row + 1][col] === current) return false;
                }
                this.status = $3d28d7f1aac198f5$var$gameStatus.LOSE;
                return true;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.status = $3d28d7f1aac198f5$var$gameStatus.PLAYING;
                this.addRandom();
                this.addRandom();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = $3d28d7f1aac198f5$var$gameStatus.IDLE;
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


"use strict";
// Uncomment the next lines to use your game instance in the browser
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
// Write your code here
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
// Wrap game field in a relative container for the tile overlay
var $197cd56b15c33885$var$wrapper = document.createElement("div");
$197cd56b15c33885$var$wrapper.className = "game-field-wrapper";
$197cd56b15c33885$var$gameField.parentNode.insertBefore($197cd56b15c33885$var$wrapper, $197cd56b15c33885$var$gameField);
$197cd56b15c33885$var$wrapper.appendChild($197cd56b15c33885$var$gameField);
var $197cd56b15c33885$var$overlay = document.createElement("div");
$197cd56b15c33885$var$overlay.className = "tile-overlay";
$197cd56b15c33885$var$wrapper.appendChild($197cd56b15c33885$var$overlay);
var $197cd56b15c33885$var$CELL_SIZE = 75;
var $197cd56b15c33885$var$CELL_GAP = 10;
var $197cd56b15c33885$var$ANIM_MS = 120;
function $197cd56b15c33885$var$tileXY(row, col) {
    return {
        x: $197cd56b15c33885$var$CELL_GAP + col * ($197cd56b15c33885$var$CELL_SIZE + $197cd56b15c33885$var$CELL_GAP),
        y: $197cd56b15c33885$var$CELL_GAP + row * ($197cd56b15c33885$var$CELL_SIZE + $197cd56b15c33885$var$CELL_GAP)
    };
}
function $197cd56b15c33885$var$createTileEl(value, row, col) {
    var pos = document.createElement("div");
    pos.className = "tile-pos";
    var _tileXY = $197cd56b15c33885$var$tileXY(row, col), x = _tileXY.x, y = _tileXY.y;
    pos.style.transform = "translate(".concat(x, "px, ").concat(y, "px)");
    var tile = document.createElement("div");
    tile.className = "tile tile--".concat(value);
    tile.textContent = value;
    pos.appendChild(tile);
    $197cd56b15c33885$var$overlay.appendChild(pos);
    return pos;
}
function $197cd56b15c33885$var$renderTiles(state) {
    var mergedSet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set(), newRow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, newCol = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
    $197cd56b15c33885$var$overlay.innerHTML = "";
    for(var row = 0; row < 4; row++){
        for(var col = 0; col < 4; col++)if (state[row][col] !== 0) {
            var pos = $197cd56b15c33885$var$createTileEl(state[row][col], row, col);
            var tile = pos.querySelector(".tile");
            if (row === newRow && col === newCol) tile.classList.add("tile--appear");
            else if (mergedSet.has("".concat(row, ",").concat(col))) tile.classList.add("tile--merge");
        }
    }
}
function $197cd56b15c33885$var$render() {
    $197cd56b15c33885$var$cells.forEach(function(cell) {
        cell.className = "field-cell";
        cell.textContent = "";
    });
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$renderTiles($197cd56b15c33885$var$game.getState());
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.status === "win") $197cd56b15c33885$var$winMessage.classList.add("hidden");
    if ($197cd56b15c33885$var$game.status === "lose") $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    if (!$197cd56b15c33885$var$startMessage.classList.contains("hidden")) $197cd56b15c33885$var$startMessage.classList.add("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.innerHTML = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    } else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$render();
});
var $197cd56b15c33885$var$isAnimating = false;
window.addEventListener("keydown", function() {
    var _ref = (0, $554ed4b40b13e16f$export$71511d61b312f219)(function(e) {
        var snap, changed, i, x, tileMap, row, col, pos, moves, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, move, pos1, _tileXY, x1, y, stateBeforeRandom, newState, newRow, newCol, row1, col1, mergedSet;
        return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($197cd56b15c33885$var$isAnimating || $197cd56b15c33885$var$game.getStatus() !== "playing") return [
                        2
                    ];
                    snap = $197cd56b15c33885$var$game.getState().map(function(row) {
                        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    });
                    switch(e.key){
                        case "ArrowUp":
                            $197cd56b15c33885$var$game.moveUp();
                            break;
                        case "ArrowDown":
                            $197cd56b15c33885$var$game.moveDown();
                            break;
                        case "ArrowLeft":
                            $197cd56b15c33885$var$game.moveLeft();
                            break;
                        case "ArrowRight":
                            $197cd56b15c33885$var$game.moveRight();
                            break;
                        default:
                            return [
                                2
                            ];
                    }
                    changed = false;
                    for(i = 0; i < 4 && !changed; i++){
                        for(x = 0; x < 4; x++)if (snap[i][x] !== $197cd56b15c33885$var$game.state[i][x]) {
                            changed = true;
                            break;
                        }
                    }
                    if (!changed) return [
                        2
                    ];
                    $197cd56b15c33885$var$isAnimating = true;
                    // Build tile elements at old positions, no transition yet
                    $197cd56b15c33885$var$overlay.innerHTML = "";
                    tileMap = new Map();
                    for(row = 0; row < 4; row++){
                        for(col = 0; col < 4; col++)if (snap[row][col] !== 0) {
                            pos = $197cd56b15c33885$var$createTileEl(snap[row][col], row, col);
                            pos.style.transition = "none";
                            tileMap.set("".concat(row, ",").concat(col), pos);
                        }
                    }
                    // Force reflow so transition: none takes effect
                    $197cd56b15c33885$var$overlay.getBoundingClientRect();
                    // Slide tiles to new positions
                    moves = $197cd56b15c33885$var$game.lastMoves;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = moves[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            move = _step.value;
                            pos1 = tileMap.get("".concat(move.fromRow, ",").concat(move.fromCol));
                            if (pos1) {
                                _tileXY = $197cd56b15c33885$var$tileXY(move.toRow, move.toCol), x1 = _tileXY.x, y = _tileXY.y;
                                pos1.style.transition = "transform ".concat($197cd56b15c33885$var$ANIM_MS, "ms ease");
                                pos1.style.transform = "translate(".concat(x1, "px, ").concat(y, "px)");
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, $197cd56b15c33885$var$ANIM_MS);
                        })
                    ];
                case 1:
                    _state.sent();
                    // Add random tile and find its position
                    stateBeforeRandom = $197cd56b15c33885$var$game.getState().map(function(row) {
                        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                    });
                    $197cd56b15c33885$var$game.addRandom();
                    newState = $197cd56b15c33885$var$game.getState();
                    newRow = -1;
                    newCol = -1;
                    outer: for(row1 = 0; row1 < 4; row1++){
                        for(col1 = 0; col1 < 4; col1++)if (stateBeforeRandom[row1][col1] === 0 && newState[row1][col1] !== 0) {
                            newRow = row1;
                            newCol = col1;
                            break outer;
                        }
                    }
                    mergedSet = new Set(moves.filter(function(m) {
                        return m.merged;
                    }).map(function(m) {
                        return "".concat(m.toRow, ",").concat(m.toCol);
                    }));
                    $197cd56b15c33885$var$renderTiles(newState, mergedSet, newRow, newCol);
                    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
                    $197cd56b15c33885$var$isAnimating = false;
                    if ($197cd56b15c33885$var$game.checkWin()) $197cd56b15c33885$var$winMessage.classList.remove("hidden");
                    if ($197cd56b15c33885$var$game.checkLose()) $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
                    return [
                        2
                    ];
            }
        });
    });
    return function(e) {
        return _ref.apply(this, arguments);
    };
}());

})();
//# sourceMappingURL=index.09026801.js.map
